export const DEFAULT_COLLAPSED_ITEM_COUNT = 3;
